export const networks = {
  bsc: {
    chainId: 56,
    rpc: { 56: "https://bsc-dataseed4.ninicoin.io/" },
    network: "binance",
    supportedChainIds: [56],
  },
  bscTestnet: {
    rpc: { 97: "https://data-seed-prebsc-1-s1.binance.org:8545" },
    chainId: 97,
    supportedChainIds: [97],
    network: "binance",
    qrcode: true,
  },
};

export const activeNetwork = "bsc";
